import { render, staticRenderFns } from "./newBillActualAmount.vue?vue&type=template&id=7b610e58&"
import script from "./newBillActualAmount.vue?vue&type=script&lang=js&"
export * from "./newBillActualAmount.vue?vue&type=script&lang=js&"
import style0 from "./newBillActualAmount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b610e58')) {
      api.createRecord('7b610e58', component.options)
    } else {
      api.reload('7b610e58', component.options)
    }
    module.hot.accept("./newBillActualAmount.vue?vue&type=template&id=7b610e58&", function () {
      api.rerender('7b610e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/BillOverseasSCenter/components/view/newBillActualAmount.vue"
export default component.exports